import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * This orchestrator is used to manage the state and interactions of the package details component.
 */
@Injectable({
  providedIn: 'root',
})
export class PackageDetailsOrchestratorService {
  quoteBreakdownVisible$ = new BehaviorSubject<boolean>(false);

  setQuoteBreakdownVisibility(visible: boolean): void {
    this.quoteBreakdownVisible$.next(visible);
  }

  toggleQuoteBreakdownVisibility(): void {
    this.quoteBreakdownVisible$.next(!this.quoteBreakdownVisible$.value);
  }
}
